import { render, staticRenderFns } from "./StatisticTile.vue?vue&type=template&id=18b5894b"
import script from "./StatisticTile.vue?vue&type=script&lang=js"
export * from "./StatisticTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports